export class Device {
    public Name: string;
    public PhoneNumber: string;
    public Email: string;
    public MasterAccountId?: string;
    public DeviceState: 'active' | 'inactive';
    public DeviceGroupIds: string[];

    public constructor(data?: any) {
        this.Name = (data && data.Name) ? data.Name : null;
        this.PhoneNumber = (data && data.PhoneNumber) ? data.PhoneNumber : null;
        this.Email = (data && data.Email) ? data.Email : null;
        this.MasterAccountId = (data && data.MasterAccountId) ? data.MasterAccountId : undefined;
        this.DeviceGroupIds = (data && data.DeviceGroupIds) ? data.DeviceGroupIds : [];
        this.DeviceState = (data && data.DeviceState) ? data.DeviceState : 'active';
    }
}
